import { render, staticRenderFns } from "./AdminModuleLayout.vue?vue&type=template&id=10c316aa&"
import script from "./AdminModuleLayout.vue?vue&type=script&lang=js&"
export * from "./AdminModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports